export default __webpack_public_path__ + "static/media/33_wah_wah.8d3be49d.png";